module.exports = __webpack_public_path__ + "static/img/hs_map.aac322d.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/uplus/hs_map.png
// module id = u33b
// module chunks = 86